import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import Avatar1 from "../../../assets/ProfileIcon.webp";
import Avatar2 from "../../../assets/ProfileIcon1.webp";
import Avatar3 from "../../../assets/ProfileIcon2.webp";
import Avatar4 from "../../../assets/ProfileIcon3.webp";
import { useThemeContext } from "../../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants";

function AvatarSelector({ selectedAvatar, onAvatarSelect, onFileSelect }) {
    const { mode } = useThemeContext();

    const defaultAvatars = [Avatar1, Avatar2, Avatar3, Avatar4];
    const [avatars, setAvatars] = useState([]);

    const sidebarIconColor = mode === "light" ? LIGHTCOLORS.GreyScale10 : DARKCOLORS.GreyScale10;
    const sidebarIconColor1 = mode === "light" ? LIGHTCOLORS.GreyScale50 : DARKCOLORS.GreyScale50;
    const sidebarIconColor2 = mode === "light" ? LIGHTCOLORS.Secondary500 : DARKCOLORS.Secondary500;

    // Populate avatars on component mount
    useEffect(() => {
        const initialAvatars = selectedAvatar ? [selectedAvatar, ...defaultAvatars] : defaultAvatars;
        setAvatars(initialAvatars);
    }, [selectedAvatar]);

    const handleAvatarSelect = (avatar) => {
        onAvatarSelect(avatar);
        onFileSelect(null); // Reset uploaded file when selecting a default avatar
    };

    // Handle avatar upload
    const handleAvatarUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!validImageTypes.includes(file.type)) {
                return;
            }

            // Generate image preview
            const reader = new FileReader();
            reader.onload = () => {
                const newAvatar = reader.result;
                setAvatars([newAvatar, ...avatars]);
                onAvatarSelect(newAvatar);
            };
            reader.readAsDataURL(file);
            onFileSelect(file);
        }
    };

    return (
        <Box className="avatar-section"
            sx={{
                display: "flex",
                alignItems: "center",
                gap: { xs: 1, sm: 2 },
                overflowX: "auto",
                padding: 1,
                  flexWrap: "wrap", // <-- Add this li
            }}
        >
            {/* Render avatars */}
            {avatars.map((avatar, index) => (
                <Box  className="profile-divs"
                    key={index}
                    onClick={() => handleAvatarSelect(avatar)}
                    sx={{
                       width:  index === 0 ? 70 : 55 ,
                        height:  index === 0 ? 70 : 55 ,
                        borderRadius: "50%", // Ensures a perfect circle
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        overflow: "hidden", // Prevents spillover
                        border: index === 0
                            ? `3px solid ${sidebarIconColor2}`
                            : "3px solid transparent",
                    }}
                >
                    <img
                        src={avatar}
                        alt={`Avatar ${index}`}
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover", // Ensures the image scales properly to fit the circle
                            borderRadius: "50%", // Makes the image itself circular
                        }}
                    />
                </Box>
            ))}

            {/* Add avatar upload option */}
            <Box className="profile-divs"
                sx={{
                    width: 55,
                    height: 55,
                    borderRadius: "70px",
                    background: sidebarIconColor,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "3px solid transparent",
                }}
            >
                <label
                    htmlFor="avatar-upload"
                    style={{ cursor: "pointer", color: sidebarIconColor1, fontSize: "28px", marginTop: "-5px" }}
                >
                    +
                </label>
                <input
                    id="avatar-upload"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleAvatarUpload}
                />
            </Box>
        </Box>
    );
}

export default AvatarSelector;
